import React, { useCallback, useEffect, useRef, useState, useContext } from "react";

import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { CerrarSesion } from "./Actiones/CerrarSesion";
import { CloseModal, OpenModal } from "./Actiones/ActionsOpenPerfil";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  addNotification as addNotificationRedux,
  setNotification,
} from "../../Actions/Auth/NotificationAction";
import { Tooltip } from '@mui/material';
import { useHistory } from "react-router-dom";
import { onDirigir } from "../helpers/RedireccionNotificaciones";
import OneSignal from "react-onesignal";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";

import { ButtonBack } from '../../Screens/PermisosUsuarios/GestioActividades/Util/ButtonBack';
import { Badge } from "@mui/material";


import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { getSignalRConnection, initSignalR } from "../../initSignalR";
import {
  addMensajeWhatsapp,
  clearMensajesWhatsapp,
  loadMensajesWhatsapp,
  removeMensajeWhatsapp,
  subscribeWhatsapp,
} from "../../whatsappStore";
import { ChatScreen } from "../Whatsapp/ChatScreen";
import { useNotifications } from "../../notifications/useNotificactions";
import { NotificacionesPanel } from "./Notificaciones/NotificacionesPanel";
import { registrarLlegadaListado } from "../../Helpers/Notificaciones/FechaNotificacion";
import { useTwilioDevice } from "../../TwilioDeviceContext";


export const HeaderScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const notifications = useSelector(
    (state) => state.notifications.notifications,
  );
  // const [notifications, setNotifications] = useState([])

  const unreadCount = useSelector((state) => state.notifications.unreadCount);
  const { roles } = useSelector((state) => state.sesion);

  const [notiSeguimiento, setNotiSeguimiento] = useState(0);


  const { idempleado } = useSelector((store) => store.usuario);

  // Canal visible del panel de notificaciones: null = cerrado.
  const [panelCanal, setPanelCanal] = useState(null);

  const [chatAbierto, setChatAbierto] = useState(false);
  const [chatData, setChatData] = useState(null);

  const [modulo, setModulo] = useState(null);

  const { addNotification } = useNotifications();
  const { empleado } = useSelector((store) => store.usuario);
  const clima = useSelector((store) => store.clima);
  const [notificaciones_activadas, setNotificacionActiva] = useState(
    OneSignal.Notifications.permission,
  );
  // Abre/cierra el drawer del menu lateral en pantallas chicas via estado global.
  // Antes se hacia con style.display inline, que ganaba sobre el CSS y no se podia cerrar.
  const openModal = () => dispatch({ type: "MENU_DRAWER_TOGGLE" });
  const [cargado, setCargado] = useState(false);
  const [idOneSignal, setIdOneSignal] = useState("");

  const [mensajesWhatsapp, setMensajesWhatsapp] = useState([]);

  const { incomingCall, numeroTelefonoActivo, callStatus } = useTwilioDevice();
  const chatAbiertoPorLlamadaRef = useRef(false);

  // 📞 al recibir una llamada entrante, abrir el ChatScreen directamente con la interfaz de llamada
  useEffect(() => {
    if (incomingCall) {
      chatAbiertoPorLlamadaRef.current = true;
      setPanelCanal(null);
      setChatData({ numeroTelefono: numeroTelefonoActivo, cliente: numeroTelefonoActivo });
      setChatAbierto(true);
    }
  }, [incomingCall, numeroTelefonoActivo]);

  // 📞 cerrar el ChatScreen cuando termina/se rechaza una llamada que lo abrió automáticamente
  useEffect(() => {
    if (callStatus === "idle" && chatAbiertoPorLlamadaRef.current) {
      chatAbiertoPorLlamadaRef.current = false;
      setChatAbierto(false);
    }
  }, [callStatus]);

  useEffect(() => {
    loadMensajesWhatsapp();
  }, []);

  // Recibir las notificaciones
  useEffect(() => {
    request
      .get(`Evento/Listado`)
      .then((result) => {
        dispatch(setNotification(result));
      })
      .catch((error) => {
        Swal.fire(
          "Error cargando notificaciones",
          JSON.stringify(error),
          "error",
        );
      });
  }, []);

  //obtener rol del usuario y modulo
  useEffect(() => {

    let moduloAsignado = null;

    const rolesUsuario = roles?.map(r => r.idrol || r);

    const tieneRolesPosventa = rolesUsuario?.some(rol =>
      ["MESP", "MERP", "MEUP"].includes(rol)
    );

    const tieneRolesCobranza = rolesUsuario?.some(rol =>
      ["MESC", "MERC", "MEUC"].includes(rol)
    );

    if (tieneRolesPosventa) {
      moduloAsignado = "POSVENTA";
    }

    if (tieneRolesCobranza) {
      moduloAsignado = "COBRANZA";
    }

    setModulo(moduloAsignado);

  }, [roles]);

  const onHome = () => {
    history.push("/Permisos/CatSeguimientoActividades")
  };


  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        // Validar estructura
        if (!event.data?.payload?.notification) return;

        const n = event.data.payload.notification;
        const notificationId = event.data.payload.notificationId;

        // Aquí están tus datos del backend
        const data = n.additionalData;

        // Validar que existe
        if (!data) return;

        let array = {
          idlog: data.idlog,
          mensaje: data.mensaje,
          parametro: data.parametro,
          portafolio: data.portafolio,
          redireccionweb: data.redireccionweb,
          notificationId: notificationId,
        };
        const existe = notifications.some(
          (item) => item.notificationId === array.notificationId,
        );
        // alert(data.mensaje);
        if (existe) {
          return;
        }
        // ✔ Ahora sí podemos agregar la notificación
        dispatch(addNotificationRedux(array));
        // console.log(data, "RESULTADO:", notifications)
        // setNotifications([data, ...notifications])
      });
    }
  }, []);


  // Borrar todo del canal Sistema. Pide confirmacion porque no hay vuelta atras.
  const handleClearNotifications = async () => {
    const confirmacion = await Swal.fire({
      title: "Borrar todas las notificaciones",
      text: "Se eliminaran todas las notificaciones del sistema. Esta accion no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, borrar todo",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ed2a35",
    });
    if (!confirmacion.isConfirmed) return;

    try {
      const resultado = await request.get(`Evento/BorrarTodo`);
      dispatch(setNotification(resultado));
    } catch (error) {
      Swal.fire("BORRAR NOTIFICACIONES", JSON.stringify(error), "error");
    }
  };

  // Borrar todo del canal WhatsApp.
  const handleClearNotificationsWhatsapp = async () => {
    const confirmacion = await Swal.fire({
      title: "Borrar todos los mensajes",
      text: "Se eliminaran todas las notificaciones de WhatsApp. Esta accion no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, borrar todo",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ed2a35",
    });
    if (!confirmacion.isConfirmed) return;

    clearMensajesWhatsapp();
    try {
      await request.get(`NotificacionesWhatsapp/borrarTodo`);
    } catch (error) {
      Swal.fire("BORRAR NOTIFICACIONES", JSON.stringify(error), "error");
      await loadMensajesWhatsapp(true);
    }
  };

  // Borrar todo desde la pestana "Todo": una sola confirmacion y se limpian
  // los dos canales, cada uno con su propio endpoint.
  const handleClearTodo = async () => {
    const confirmacion = await Swal.fire({
      title: "Borrar todas las notificaciones",
      text: "Se eliminaran las notificaciones del sistema y los mensajes de WhatsApp. Esta accion no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, borrar todo",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ed2a35",
    });
    if (!confirmacion.isConfirmed) return;

    try {
      const resultado = await request.get(`Evento/BorrarTodo`);
      dispatch(setNotification(resultado));
    } catch (error) {
      Swal.fire("BORRAR NOTIFICACIONES", JSON.stringify(error), "error");
    }

    clearMensajesWhatsapp();
    try {
      await request.get(`NotificacionesWhatsapp/borrarTodo`);
    } catch (error) {
      Swal.fire("BORRAR NOTIFICACIONES", JSON.stringify(error), "error");
      await loadMensajesWhatsapp(true);
    }
  };

  // Abrir un grupo navega una vez y descarta todos sus idlog.
  const onRedirigir = (grupo) => {
    onDirigir(grupo.parametro, grupo.portafolio, history, grupo.redireccionweb);
    setPanelCanal(null);

    // Esperar a que ocurra la navegacion
    setTimeout(() => {
      removeNotificaciones(grupo.idlogs);
    }, 300);
  };

  // Se llama Evento/Borrar por cada idlog del grupo, en secuencia, y solo se
  // pinta la ultima respuesta para no repintar el listado N veces.
  const removeNotificaciones = async (idlogs = []) => {
    if (idlogs.length === 0) return;
    try {
      let ultimoResultado = null;
      for (const idlog of idlogs) {
        ultimoResultado = await request.get(
          `Evento/Borrar?idlog=${encodeURIComponent(idlog)}`,
        );
      }
      if (ultimoResultado) dispatch(setNotification(ultimoResultado));
    } catch (error) {
      Swal.fire("BORRAR NOTIFICACIONES", JSON.stringify(error), "error");
    }
  };

  // WhatsApp agrupa por cliente: se descartan todos los mensajes del grupo.
  const removeMensajesWhatsapp = async (idsMensaje = []) => {
    idsMensaje.forEach((id) => removeMensajeWhatsapp(id));
    try {
      for (const id of idsMensaje) {
        await request.get(
          `NotificacionesWhatsapp/borrarNotificacion?idnotificacion=${encodeURIComponent(id)}`,
        );
      }
    } catch (error) {
      Swal.fire("BORRAR NOTIFICACIONES", JSON.stringify(error), "error");
      await loadMensajesWhatsapp(true);
    }
  };

  const handleNotificationsClick = async () => {
    if (OneSignal.Notifications.permission === false) {
      if (window.OneSignal) {
        window.OneSignal.Slidedown.promptPush(); // 👈 Lanza el slidedown configurado.
      }
    } else {
      setPanelCanal(panelCanal === "todo" ? null : "todo");
    }
  };

  const handleWhatsappClick = () => {
    setPanelCanal(panelCanal === "whatsapp" ? null : "whatsapp");
  };

  const cerrarPanel = useCallback(() => setPanelCanal(null), []);

  // La campana suma ambos canales: llegue por donde llegue, el contador sube.
  const totalPendientes = unreadCount + mensajesWhatsapp.length;

  const abrirChat = (notification) => {
    setPanelCanal(null);
    setChatData(notification);
    setChatAbierto(true);
  };

  useEffect(() => {
    if (OneSignal.Notifications.permission === true) {
      setIdOneSignal(OneSignal.User.PushSubscription.id);
      setNotificacionActiva(true);
    }
  }, [OneSignal.Notifications.permission]);

  const onGuardarID = (id) => {
    request
      .post("OneSignal", {
        usuario: "",
        codigoseguridad: "",
        oneSignalID: id,
      })
      .then((result) => setCargado(true))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (
      idOneSignal !== undefined &&
      idOneSignal !== null &&
      idOneSignal !== "" &&
      OneSignal.Notifications.permission === false
    ) {
      onGuardarID(idOneSignal);
    }
  }, [idOneSignal]);

  useEffect(() => {
    const unsubscribe = subscribeWhatsapp(setMensajesWhatsapp);
    return unsubscribe;
  }, []);

  // Respaldo de fecha: se registra cuando cada notificacion se vio por primera
  // vez. Se hace aqui y no en el panel para que la hora sea correcta aunque el
  // panel este cerrado. Cuando el backend mande "fecha", esta tiene prioridad.
  useEffect(() => {
    registrarLlegadaListado(notifications, (item) => item.idlog);
  }, [notifications]);

  useEffect(() => {
    registrarLlegadaListado(mensajesWhatsapp, (item) => item.idMensaje);
  }, [mensajesWhatsapp]);
  useEffect(() => {
    let conn;
    let handler;

    const init = async () => {
      conn = await initSignalR(idempleado);
      if (!conn) return;

      handler = (mensaje) => {
        addNotification({ message: mensaje.mensaje, data: mensaje });
        addMensajeWhatsapp(mensaje);
      };

      conn.on("ReceiveNotification", handler);
    };

    init();

    return () => {
      if (conn && handler) {
        conn.off("ReceiveNotification", handler);
      }
    };
  }, []);

  useEffect(() => {
    if (cargado === true) return;
    // 1. Definir la función asíncrona dentro de useEffect
    const initOneSignal = async () => {
      try {
        // Inicializar OneSignal (se hace primero para que el listener funcione)
        await OneSignal.init({
          appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
          // allowLocalhostAsSecureOrigin: true,
          promptOptions: {
            slidedown: {
              prompts: [
                {
                  type: "push",
                  autoPrompt: false,
                  text: {
                    actionMessage: "¿Deseas recibir notificaciones?",
                    acceptButton: "Aceptar",
                    cancelButton: "No gracias",
                  },
                },
              ],
            },
          },
        });
      } catch (error) {
        console.error("❌ Error al inicializar OneSignal:", error);
      }
    };

    // 2. Definir el handler del listener
    const subscriptionChangeHandler = (sub) => {
      const id = sub?.current?.id;
      if (id) {
        console.log("✔ ID de suscripción obtenido:", id);
        setIdOneSignal(id);
        setNotificacionActiva(true);
        onGuardarID(id);
        // request
        //   .post("/OneSignal", {
        //     usuario: "",
        //     codigoseguridad: "",
        //     oneSignalID: idOneSignal,
        //   })
        //   .then((result) => console.log(result))
        //   .catch((error) => console.log(error));
      } else {
        console.warn("⚠ Evento change llegó, pero sin ID todavía.");
      }
    };

    // 3. Añadir el listener
    OneSignal.User.PushSubscription.addEventListener(
      "change",
      subscriptionChangeHandler,
    );

    // 4. Ejecutar la inicialización
    initOneSignal();

    // 5. DEVOLVER LA FUNCIÓN DE LIMPIEZA
    return () => {
      // Al desmontar el componente, eliminamos el listener
      OneSignal.User.PushSubscription.removeEventListener(
        "change",
        subscriptionChangeHandler,
      );
      console.log("🗑 Cleanup: Event Listener de OneSignal eliminado.");
    };
  }, []); // Dependencia vacía para que se ejecute solo al montar
  return (
    <>
      <div id="hd-header-screen">
        <div id="hd-header-screen-container">
          <div className="hd-header-titulo">
            <div className="hd-header-titulo-menu">
              <MenuIcon onClick={() => openModal()} />
            </div>
          </div>
          <div className="hd-header-actions">

            {/* <div
              className="hd-header-actions-whatsapp"
              onClick={() => handleWhatsappClick()}
            >
              <WhatsAppIcon />
              {mensajesWhatsapp.length > 0 && (
                <div className="counter">{mensajesWhatsapp.length}</div>
              )}
            </div> */}

            <div className="hd-header-actions-help">
              <div
                onClick={async () => {

                  //MARCAR COMO REVISADO
                  await request.post("SeguimientoAct/MarcarRevisado");

                  //LIMPIAR CONTADOR
                  setNotiSeguimiento(0);

                  onHome();
                }}
              >
                <Tooltip title="Seguimiento Actividades">

                  <Badge
                    badgeContent={notiSeguimiento}
                    color="error"
                    invisible={notiSeguimiento === 0}
                  >
                    <HelpOutlineIcon />
                  </Badge>

                </Tooltip>
              </div>
            </div>

            <div className="hd-header-notif-anchor">
              <div
                className="hd-header-actions-alert"
                onClick={() => handleNotificationsClick()}
              >
                {notificaciones_activadas ? (
                  <NotificationsIcon />
                ) : (
                  <NotificationsOffIcon className="notificacion_desactivada" />
                )}
                {notificaciones_activadas && totalPendientes > 0 && (
                  <div className="counter">{totalPendientes}</div>
                )}
              </div>

              {panelCanal && (
                <NotificacionesPanel
                  canal={panelCanal}
                  onCambiarCanal={setPanelCanal}
                  onCerrar={cerrarPanel}
                  notificaciones={notifications}
                  mensajesWhatsapp={mensajesWhatsapp}
                  onAbrirNotificacion={onRedirigir}
                  onEliminarNotificacion={removeNotificaciones}
                  onBorrarTodoSistema={handleClearNotifications}
                  onAbrirChat={abrirChat}
                  onEliminarWhatsapp={removeMensajesWhatsapp}
                  onBorrarTodoWhatsapp={handleClearNotificationsWhatsapp}
                  onBorrarTodo={handleClearTodo}
                />
              )}
            </div>
            <div className="hd-header-actions-clima">
              <img src={clima.icono} alt="icon" />
              <div>{clima.temperatura}ºC</div>
            </div>
            <a className="hd-header-actions-user" onClick={OpenModal}>
              <div className="hd-header-actions-user-datos">
                <div className="hd-header-actions-user-datos-nombre">
                  <div className="hd-header-actions-user-datos-nombre-msg">
                    ¡Bienvenido!
                  </div>
                  <div className="hd-header-actions-user-datos-nombre-user">
                    {empleado}
                  </div>
                </div>
              </div>
            </a>
          </div>
          <ChatScreen
            open={chatAbierto}
            onClose={() => setChatAbierto(false)}
            numeroTelefono={chatData?.numeroTelefono}
            cliente={chatData?.cliente}
            modulo={modulo}
          />
        </div>

        <div
          id="hd-header-perfil-usuario"
          onClick={CloseModal}
          className="hd-header-perfil-usuario"
        >
          <div className="hd-header-perfil-usuario-datos">
            <div
              className="hd-header-perfil-cerrar-sesion"
              onClick={CerrarSesion}
            >
              Cerrar Sesión
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
